import {
    IGridModelView,
    IMeasureBag,
    IMutableGridModel
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {DataGridView} from '@mintdata-wsp/wsp/ui/components/grid/DataGridView';
import {GridMeasureView} from '@mintdata-wsp/wsp/ui/components/grid/measure/GridMeasureView';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ListGridView.less');
const cx = classnames.bind(styles);

export interface ListGridViewProps
{
    gridModel:IMutableGridModel;
    className?:string;
}

@observer
export class ListGridView extends React.Component<ListGridViewProps, any>
{
    @observable
    private _haveMeasured:boolean = false;

    constructor(props:ListGridViewProps)
    {
        super(props);
        this._init();
    }

    componentWillReceiveProps(nextProps: Readonly<ListGridViewProps>, nextContext: any): void
    {
        this._init();
    }

    componentWillUnmount(): void
    {
    }

    @action.bound
    private _init()
    {
        this._haveMeasured = false;
    }

    @action.bound
    private _onMeasureDone(bag:IMeasureBag)
    {
        // console.log(`ListGridView :: _onMeasureDone: bag:`);
        // bag.print();

        this._haveMeasured = true;
        this._updateGridModelSizes(bag);
    }

    @bind
    private _updateGridModelSizes(bag:IMeasureBag):void
    {
        const view = this.getView();

        for( let colIndex = 0; colIndex < bag.getNumColumns(); colIndex++ )
        {
            let widestColumn = bag.getWidestColumn(colIndex);

            // console.log(`setColumnWidth[${colIndex}] => ${widestColumn}`);
            view.setColumnWidth(colIndex, widestColumn);
        }
    }

    private getView():IGridModelView
    {
        const {gridModel} = this.props;
        return gridModel.getBodyWithBothHeaders();
    }

    render()
    {
        const {gridModel, className} = this.props;
        const view = this.getView();

        return  <div className={cx('listGridView')}>
                    {
                        this._haveMeasured?
                            <DataGridView className={className} gridModel={gridModel}/>
                            :
                            null
                    }

                    {
                        !this._haveMeasured ?
                            <GridMeasureView isVisible={true}
                                             className={cx('listMeasureContainer')}
                                             id={IdUtil.newGUID()}
                                             onMeasureDone={this._onMeasureDone}

                                             gridModel={gridModel}
                                             viewToMeasure={view}
                                             numRowsToMeasure={1}
                                             numColumnsToMeasure={view.getNumColumns()}

                                             verticalCellPadding={3}
                                             horizontalCellPadding={5}
                            />
                            :
                            null
                    }
                </div>
    }
}
